import logo2009 from "../../assets/img/historicEvents/LogoTLC/2009.png";
import logo2010 from "../../assets/img/historicEvents/LogoTLC/2010.png";
import logo2011_2013 from "../../assets/img/historicEvents/LogoTLC/2011-2013.png";
import logo2014 from "../../assets/img/historicEvents/LogoTLC/2014.png";
import logo2015_2016 from "../../assets/img/historicEvents/LogoTLC/2015-2016.png";
import logo2017 from "../../assets/img/historicEvents/LogoTLC/2017.png";
import logo2018_2019 from "../../assets/img/historicEvents/LogoTLC/2018-2019.png";
import logo2020 from "../../assets/img/historicEvents/LogoTLC/2020.png";

export const tlcDetail = {
  tlc: {
    id: "tlc",
    title: "TLC: Tables, Ladders & Chairs",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "tlc",
        items: [
          {
            id: "tlc-2009",
            title: "TLC",
            description: "Tables, Ladders & Chairs 2009",
            imgUrl: logo2009,
          },
          {
            id: "tlc-2010",
            title: "TLC",
            description: "Tables, Ladders & Chairs 2010",
            imgUrl: logo2010,
          },
          {
            id: "tlc-2011",
            title: "TLC",
            description: "Tables, Ladders & Chairs 2011 - 2012",
            imgUrl: logo2011_2013,
          },
          {
            id: "tlc-2013",
            title: "TLC",
            description: "It's Not Tender, Loving Care... It's Tables, Ladders and Chairs 2013",
            imgUrl: logo2011_2013,
          },
          {
            id: "tlc-2014",
            title: "TLC",
            description: "The Demolition Derby of the WWE 2014",
            imgUrl: logo2014,
          },
          {
            id: "tlc-2015",
            title: "TLC",
            description: "Tables, Ladders & Chairs 2015 - 2016",
            imgUrl: logo2015_2016,
          },
          {
            id: "tlc-2017",
            title: "TLC",
            description: "Tables, Ladders & Chairs 2017",
            imgUrl: logo2017,
          },
          {
            id: "tlc-2018",
            title: "TLC",
            description: "Tables, Ladders & Chairs 2018 - 2019",
            imgUrl: logo2018_2019,
          },
          {
            id: "tlc-2020",
            title: "TLC",
            description: "Tables, Ladders & Chairs 2020",
            imgUrl: logo2020,
          },
        ],
      },
    ],
  },
};
